module.exports = __webpack_public_path__ + "a71ced544c39ed62f1f2be93d58e0523.jpg";